export const FIREBASE_MESSAGES = {
	"Storage name already exists": "storageNameAlreadyExists",
    "invalid-argument": "invalidArgument",
    "auth/email-already-in-use": "emailAlreadyInUse",
    "auth/invalid-email": "invalidEmail",
    "auth/weak-password": "weakPassword",
    "customerIdAlreadyExists": "customerIdAlreadyExists",
	"EMAIL_CONFIRMATION_REQUIRED": "errorEmailConfirmationRequired",
    "BARCODE_ALREADY_EXISTS": "errorBarcodeAlreadyExists",
    "TOO_MANY_BARCODES": "errorTooManyBarcodes",
    "AI_PRODUCT_SUGGESTIONS_NOT_SUPPORTED": "errorAiProductSuggestionsNotSupported",
    "AI_PRODUCT_SUGGESTIONS_DAILY_LIMIT_REACHED": "errorAiProductSuggestionsDailyLimitReached",
    "AI_PRODUCT_SUGGESTIONS_FAILED": "errorAiProductSuggestionsFailed",
    "INVALID_AI_IMAGES": "errorInvalidAiImages",
    "PRODUCT_LIMIT_REACHED": "errorProductLimitReached",
}

// Application Configuration Constants
export const APP_CONFIG = {
    // Pagination and limits
    DEFAULT_DOC_LIMIT: 10,
    DEFAULT_SEARCH_LIMIT: 10,
    MAX_SEARCH_RESULTS: 25,
    
    // Timeouts and delays
    FILTER_DEBOUNCE_DELAY: 250, // ms
    VALIDATION_TIMEOUT: 500, // ms
    RETRY_DELAY_BASE: 100, // ms
    
    // Retry configuration
    MAX_RETRY_ATTEMPTS: 10,
    
    // Batch processing
    DEFAULT_BATCH_SIZE: 500,
    
    // Soft-deleted storages and categories are purged after this many days
    PERMANENT_DELETION_GRACE_DAYS: 30,

    // UI Constants
    LOW_STOCK_THRESHOLD: 15,
    MAX_DISPLAY_ITEMS: 40,
    
    // Security
    MIN_PASSWORD_LENGTH: 8,
    MAX_PASSWORD_LENGTH: 128,
    
    // Animation durations (in seconds)
    SHORT_ENTER_ANIMATION_DURATION: 0.25,
    SHORT_EXIT_ANIMATION_DURATION: 0.2,
    LONG_EXIT_ANIMATION_DURATION: 0.2,
    FAST_ANIMATION_DURATION: 0.1,
    MICRO_ANIMATION_DURATION: 0.08,
    ULTRA_FAST_ANIMATION_DURATION: 0.04,
} as const

// Environment-based configuration
export const getConfig = () => {
    const isDevelopment = import.meta.env.VITE_MODE === 'development'
    //const isProduction = import.meta.env.VITE_MODE === 'production'
    
    return {
        ...APP_CONFIG,
        // Override for development/production if needed
        ENABLE_LOGGING: isDevelopment,
        LOG_SENSITIVE_DATA: false, // Always false for security
    }
}

